import {View} from 'react-native'
import {useReducedMotion} from 'react-native-reanimated'
import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import flyLikeHeartsData from '../../../assets/capsule/lottie/fly-like-hearts.json'

/**
 * LikeHearts (web) — the one-shot "hearts fly up from the like button" burst
 * used on the capsule video screen.
 *
 * Uses @lottiefiles/dotlottie-react with the raw JSON passed via `data` so no
 * extra static asset URL handling is needed. The asset's canvas is 600×600 and
 * the burst launches from (300, 420) — (50%, 70%) of the square — so the
 * consumer anchors that point to the tapped like button (page coordinates).
 * The animation replays on every remount (key on the burst id).
 *
 * Reduced-motion users get nothing — the burst is purely decorative.
 */
export function LikeHearts({
  x,
  y,
  size = 320,
}: {
  /** Anchor X in the parent's local coordinate space. */
  x: number
  /** Anchor Y in the parent's local coordinate space. */
  y: number
  /** Square size of the animation canvas. */
  size?: number
}) {
  const reducedMotion = useReducedMotion()

  if (reducedMotion) return null

  return (
    <View
      pointerEvents="none"
      style={{
        position: 'absolute',
        left: x - size / 2,
        top: y - size * 0.7,
        width: size,
        height: size,
      }}>
      {/* @ts-ignore data is web-only — plain Lottie JSON object */}
      <DotLottieReact
        data={flyLikeHeartsData}
        autoplay
        loop={false}
        style={{width: '100%', height: '100%'}}
      />
    </View>
  )
}
